// Vendors
import {
  TrackingEventsEnum,
  TrackingLinkEventReturnType,
  TrackingViewEventReturnType,
} from '@openbank/ziniaweb-ui-core-models';
// Types
import { TrackBuilderType } from 'types/track-builder.type';
import { ContractOtpTrackingHandlersType } from './types/contract-otp.tracking.handlers.type';

const contractOtpPageDisplayedTracking = (): TrackingViewEventReturnType => ({
  payload: {
    pageName: 'otpPhoneConfirmation',
    sectionFamily: 'customer',
    sectionCategory: 'orders',
    sectionName: 'lending',
    interactionType: 'funnel',
    serviceType: 'userSettings',
    processType: 'signAndPayment',
  },
  type: TrackingEventsEnum.VIEW,
});

const continueButtonClickTracking = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'continue',
    format: 'button',
    component: 'navigationFooter',
    element: 'continue',
    eventCategory: 'ContractOtp',
    eventAction: 'clickButton',
    eventLabel: 'continueButton',
  },
  type: TrackingEventsEnum.LINK,
});

const errorMessageDisplayedTracking = (errorDescription: string): TrackingLinkEventReturnType => ({
  payload: {
    action: 'error',
    format: 'otpAuthentication',
    component: 'inputOTP',
    element: errorDescription,
    errorCategory: 'otpError',
    eventCategory: 'ContractOtp',
    eventAction: 'clickTextBox',
    eventLabel: 'textBox - error',
    errorDescription,
  },
  type: TrackingEventsEnum.LINK,
});

const textboxClickTracking = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'type',
    format: 'textBox',
    component: 'OTP/SMS',
    element: 'otp',
    eventCategory: 'ContractOtp',
    eventAction: 'clickTextBox',
    eventLabel: 'otpTextBox',
  },
  type: TrackingEventsEnum.LINK,
});

const otpStartTracking = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'start',
    format: 'otpAuthentication',
    component: 'OTP/SMS',
    element: 'backend',
    eventCategory: 'ContractOtp',
    eventAction: 'otpAuthenticationSMS',
    eventLabel: 'start',
  },
  type: TrackingEventsEnum.LINK,
});

const resendOtpLinkTracking = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'send',
    format: 'link',
    component: 'OTP/SMS',
    element: 'requestANewCode',
    eventCategory: 'ContractOtp',
    eventAction: 'clickLink',
    eventLabel: 'requestANewCodeLink',
  },
  type: TrackingEventsEnum.LINK,
});

const ContractOtpTrackingHandlers = (track: TrackBuilderType): ContractOtpTrackingHandlersType => ({
  handleClickResendOtpTracking: () => track(resendOtpLinkTracking()),
  handleContractOtpPageDisplayedTracking: () => track(contractOtpPageDisplayedTracking()),
  handleOtpStartTracking: () => track(otpStartTracking()),
  handleContinueButtonClickTracking: () => track(continueButtonClickTracking()),
  handleTextboxClickTracking: () => track(textboxClickTracking()),
  handleErrorMessageDisplayedTracking: (errorDescription: string) =>
    track(errorMessageDisplayedTracking(errorDescription)),
});

export { ContractOtpTrackingHandlers };
